<template>
  <div
    class="auth-wrapper auth-v1"
    style="background-color: #eff1f3"
  >
    <div class="auth-inner py-2">

      <!-- Register v1 -->
      <b-card class="mb-0">
        <b-link
          class="brand-logo"
          @click="$router.push('/')"
        >
          <logo-vsl-booster />

        </b-link>
        <validation-observer ref="registerForm">
          <b-form
            class="auth-register-form"
            @submit.prevent
          >
            <b-row>
              <b-col cols="12">
                <div class="d-flex justify-content-center mb-2">
                  <img
                    width="150"
                    src="https://assets.kiwify.com.br/images/pix-bc-logo-4.png"
                    class="w-32"
                    style="align-self: flex-start;"
                  >
                </div>
                <div class="text-center px-12 mt-8">
                  <h3 class="text-2xl font-bold text-green-600">
                    Pedido gerado! Agora finalize o pagamento
                  </h3>
                </div>
              </b-col>
              <b-col
                cols="12"
                style="padding: 1rem 4rem"
              >
                <div class="block md:hidden text-black text-left mt-8">
                  1. Aperte em <b>"Copiar Código"</b>.<br> 2. Abra o app do seu banco e entre na opção Pix.<br> 3. Escolha a opção <b>Pagar / Pix copia e cola</b>.<br> 4. Depois, confirme o pagamento. <br></div>
                <div class="hidden md:block text-black text-left px-12 mt-8">
                  1. Abra o app do seu banco e entre na opção <b>Pix</b>.<br> 2. Escolha a opção <b>Pagar / Pix copia e cola</b> .<br> 3. Escaneie o QR code. Se preferir, copie e cole o código.<br> 4. Depois, confirme o pagamento. <br></div>
                <div class="text-center text-black mt-2">
                  A aprovação leva no máximo 2 minutos.
                </div>
              </b-col>
              <b-col cols="12">
                <div class="d-flex justify-content-center">
                  <img :src="data_payment.qr_code_url" alt="QR CODE">
                </div>
                <div class="d-flex justify-content-center my-1">
                  <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="primary"
                      @click="copyCode"
                  >
                    <feather-icon
                        icon="CopyIcon"
                        class="mr-50"
                    />
                    <span class="text-uppercase align-middle">Copiar Código Pix</span>
                  </b-button>
                </div>
                <div class="d-flex justify-content-center my-1">
                  <a href="/dashboard" style="text-decoration: underline"><span class="text-uppercase">já fiz o pagamento</span></a>
                </div>
              </b-col>

              <b-col
                cols="12"
                class="d-flex justify-content-between px-3"
                style="border-top: 1px solid #e4e4e4; padding-top: 0.5rem"
              >
                <div class="text-center text-black mt-2">
                  <h3 class="text-2xl font-bold text-green-600">
                    Total
                  </h3>
                </div>
                <div class="text-center text-black mt-2">
                  <h3 class="text-2xl font-bold text-green-600">
                    R$ {{ converteValue(data_payment.amount) }}
                  </h3>
                </div>
              </b-col>
            </b-row>

          </b-form>
        </validation-observer>
        <b-overlay
          :show="false"
          no-wrap
        >
          <b-skeleton
            class="w-100"
            height="100%"
            type="form"
            variant="light"
          />
        </b-overlay>
      </b-card>
    </div>
  </div>

</template>

<script>
import { ValidationObserver } from 'vee-validate'
import {
  BCard, BLink, BForm, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import LogoVslBooster from '@/components/LogoVslBooster.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    LogoVslBooster,
    // BSV
    BCard,
    BLink,
    BForm,
    // validations
    ValidationObserver,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      interval: null,
    }
  },
  computed: {
    data_payment() {
      return this.$store.getters['appPayment/data_payment']
    },
  },
  mounted() {
    if (this.data_payment === null) {
      this.$router.push({ name: 'payment' })
    }

    this.interval = setInterval(() => {
      this.$store.dispatch('appPayment/findByIdOrder', { id: this.$store.getters['appPayment/id_pedido_pagarme'] })
        .then(resp => {
          if (resp.data.success) {
            if (resp.data.data.status === 'paid') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Aprovação',
                  text: 'Pagamento aprovado com sucesso!',
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              this.$router.push('/dashboard')
            }
          }
        })
    }, 120000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    converteValue(val) {
      const valorReal = val / 100
      return valorReal.toLocaleString('pt-br', { minimumFractionDigits: 2 })
    },
    copyCode() {
      const el = document.createElement('textarea')
      el.value = this.data_payment.qr_code
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Código copiado',
          text: 'O código foi copiado com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-auth.scss';

.auth-wrapper.auth-v1 .auth-inner {
  max-width: 600px !important;
}
</style>
